import { every, findIndex, isEmpty } from 'lodash';
import moment from 'moment';
import queryString from 'query-string';

import * as types from './constants';
import { sorts } from '../../../pages/Performance/components/LinksTab/sort';
import { generateQueryFromString, removeFromQueryString } from '../../../utils/queryString';

const initialDate = () => {
  const currentDate = moment.utc();
  const startSubtract = currentDate.clone().startOf('day').subtract(30, 'days').format();

  return { key: 'date', filterTitle: 'Date', selected: false, value: { since: startSubtract, until: currentDate.endOf('day').format(), type: 'last_days', number: 30 } };
};

export const initialState = {
  listData: {
    dataTable: [],
    allSelected: false,
    apiFilters: null,
    // campaign_modifiers: [],
    loading: false,
    tagsLoading: false,
    count: 0,
    next: null,
    previous: null,
    curr_page: 1,
    errors_api: {},
    queryParsed: false,
    message: null,
    tags: [],
    usersToFilter: [],
    filters: [
      { ...initialDate() },
      { key: 'users', filterTitle: 'Users', selected: false, value: [] },
      { key: 'tags', filterTitle: 'Tags', selected: false, value: [] },
      // { key: 'campaign_modifiers', filterTitle: 'Bonuses', selected: false, value: [] },
      { key: 'campaigns', filterTitle: 'Bonuses', selected: false, value: [] },
      { key: 'lookbooks', filterTitle: 'Lookbooks', selected: false, value: [] },
      { key: 'discount_codes', filterTitle: 'Discount codes', selected: false, value: [] },
      { key: 'connected_since', filterTitle: 'Connected in last 7 days', selected: false, value: false },
      { key: 'active_links_range', filterTitle: 'Active Links', selected: false, value: { min: '', max: '' } },
      { key: 'clicks_range', filterTitle: 'Clicks', selected: false, value: { min: '', max: '' } },
      { key: 'gmv_range', filterTitle: 'Sales', selected: false, value: { min: '', max: '' } },
      { key: 'sort', filterTitle: 'Sort', selected: true, value: sorts.default }
    ]
  }
};

const actions = {

  // Get Performance Links
  [types.GET_PERFORMANCE_LINKS_REQUEST]: state => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: true
      }
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_LINKS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        ...payload
      }
    };

    return { ...data };
  },

  [types.GET_PERFORMANCE_LINKS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      listData: {
        ...state.listData,
        loading: false,
        errors_api: payload
      }
    };

    return { ...data };
  },

  // Operations
  [types.UPDATE_USER_PERFORMANCE_LINKS]: (state, { payload }) => {
    const newDataTable = state.listData.dataTable.map(el => el.owner_uuid === payload.uuid ? {
      ...el,
      user: payload
    } : el);

    const data = {
      ...state,
      listData: {
        ...state.listData,
        dataTable: newDataTable
      }
    };

    return { ...data };
  },

  [types.TOGGLE_PERFORMANCE_LINKS]: (state, { payload }) => {
    const newDataTable = state.listData.dataTable.map(el => el.link.id === payload ? {
      ...el,
      link: { ...el.link, id: el.link.id, selected: !el.link.selected },
      checkbox: { ...el.checkbox, id: el.link.id, selected: !el.link.selected }
    } : el);

    const status = every(newDataTable, x => x.link.selected);

    const data = {
      ...state,
      listData: {
        ...state.listData,
        allSelected: status,
        dataTable: newDataTable
      }
    };

    return { ...data };
  },

  [types.TOGGLE_ALL_PERFORMANCE_LINKS]: state => {

    const status = every(state.listData.dataTable, x => x.link.selected);

    const data = {
      ...state,
      listData: {
        ...state.listData,
        allSelected: !status,
        dataTable: state.listData.dataTable.map(el => ({
          ...el, link: { ...el.link, id: el.link.id, selected: !status },
          checkbox: { ...el.checkbox, id: el.link.id, selected: !status }
        }))
      }
    };

    return { ...data };
  },

  [types.SET_PERFORMANCE_LINKS_USERS_TO_FILTER]: (state, { payload }) => {
    const stripUuidSuffix = str => str.includes('_') ? str.slice(0, str.lastIndexOf('_')) : str;

    localStorage.setItem('usersToFilter', JSON.stringify(payload.map(user => user.user ? user : { uuid: stripUuidSuffix(user.uuid), checked: true, ...user })));

    const data = {
      ...state,
      listData: {
        ...state.listData
        // usersToFilter: payload.map(user => user.user ? user : { uuid: stripUuidSuffix(user.uuid), checked: true, ...user })
      }
    };

    return { ...data };
  },

  [types.SET_PERFORMANCE_LINKS_FILTER]: (state, { payload }) => {
    const index = findIndex(state.listData.filters, x => x.key === payload.key);
    const updatedFilters = [...state.listData.filters];
    if (index !== -1) {
      updatedFilters[index].value = payload.value;
      if (typeof updatedFilters[index].value === 'string' || Array.isArray(updatedFilters[index].value)) {
        updatedFilters[index].selected = !isEmpty(updatedFilters[index].value);
      } else {
        updatedFilters[index].selected = !isEmpty(updatedFilters[index].value.type);
      }
    }

    const data = {
      ...state,
      listData: {
        ...state.listData,
        filters: updatedFilters,
        curr_page: 1
      }
    };

    return { ...data };
  },

  [types.SET_PERFORMANCE_LINKS_ALL_FILTERS]: (state, { payload }) => {
    let updatedFilters = [...state.listData.filters];

    payload.forEach(filter => {
      const index = findIndex(updatedFilters, x => x.key === filter.key);
      if (index !== -1) updatedFilters[index] = { ...updatedFilters[index], selected: true, ...filter };
    });

    const data = {
      ...state,
      listData: {
        ...state.listData,
        filters: updatedFilters,
        curr_page: 1,
        queryParsed: true
      }
    };

    return { ...data };
  },

  [types.CLEAR_PERFORMANCE_LINKS_FILTERS]: (state, { payload: { filterToUpdate, mobile } }) => {
    if (!isEmpty(filterToUpdate)) {
      const index = findIndex(state.listData.filters, x => x.key === filterToUpdate.key);
      const updatedFilters = [...state.listData.filters];
      if (index !== -1) {
        updatedFilters[index].value = filterToUpdate.value;
        updatedFilters[index].selected = filterToUpdate.selected;
      }

      const data = {
        ...state,
        listData: {
          ...state.listData,
          filters: updatedFilters,
          curr_page: 1
        }
      };

      if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}${removeFromQueryString(filterToUpdate.key)}`);

      return { ...data };
    } else {
      const data = {
        ...state,
        listData: {
          ...state.listData,
          filters: [
            { ...initialDate() },
            { key: 'users', filterTitle: 'Users', selected: false, value: [] },
            { key: 'tags', filterTitle: 'Tags', selected: false, value: [] },
            { key: 'campaigns', filterTitle: 'Campaigns', selected: false, value: [] },
            { key: 'lookbooks', filterTitle: 'Lookbooks', selected: false, value: [] },
            { key: 'discount_codes', filterTitle: 'Discount codes', selected: false, value: [] },
            { key: 'connected_since', filterTitle: 'Connected in last 7 days', selected: false, value: false },
            { key: 'sort', filterTitle: 'Sort By', selected: true, value: sorts.default }
          ],
          curr_page: 1
        }
      };

      const query = generateQueryFromString(window.location.search);

      if (query.tab) {
        if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}?${queryString.stringify({ tab: query.tab })}`);
      } else {
        if (!mobile) window.history.replaceState({}, '', `${window.location.pathname}`);
      }

      return { ...data };
    }
  },

  [types.PERFORMANCE_LINKS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      listData: {
        ...state.listData,
        curr_page: parseInt(payload) || 1,
        queryParsed: true
      }
    };

    return { ...data };
  },

  [types.PERFORMANCE_LINKS_ERRORS_RESET]: state => {
    return {
      ...state,
      listData: {
        ...state.listData,
        errors_api: {
          ...initialState.listData.errors_api
        }
      }
    };
  },

  [types.PERFORMANCE_LINKS_RESET]: () => {

    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

